/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-popup-container,.mat-popup-help-container{background-color:transparent;height:auto;padding:0!important}"];
export { styles as styles };
